import { AodRun } from '@app/modules/audit/modules/aod/aod.types';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';

interface Props {
  run: AodRun;
}

export function ReprocessCompletion({ run }: Props) {
  const { $t } = useIntl();

  if (!run.isReprocessCompleted) {
    return null;
  }

  return (
    <Box>
      <CheckCircleIcon />{' '}
      {$t({
        id: 'audit.aod.actions.triggerReprocess.completed',
        defaultMessage: 'Reprocesamiento completado',
      })}
    </Box>
  );
}
